var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraffic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#E8EDF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4636_42612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4375 47C40.4375 45.4467 39.1783 44.1875 37.625 44.1875H26.375C24.8217 44.1875 23.5625 45.4467 23.5625 47V48H40.4375V47Z",
    fill: "url(#paint0_linear_4636_42612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.125 23.5625V21.6875H34.6398C34.3566 20.8932 33.7318 20.2684 32.9375 19.9852V16H31.0625V19.9852C30.2682 20.2684 29.6434 20.8932 29.3602 21.6875H17.875V23.5625H20.219L16 33.875C16 36.4596 18.1029 38.5625 20.6875 38.5625H22.5625C25.1471 38.5625 27.25 36.4596 27.25 33.875L23.0119 23.5625H29.3603C29.6435 24.3568 30.2683 24.9816 31.0626 25.2648V38.6653C29.2304 39.0402 27.781 40.4796 27.4074 42.3125H36.5927C36.2191 40.4796 34.7698 39.0402 32.9376 38.6653V25.2648C33.7318 24.9816 34.3566 24.3568 34.6399 23.5625H40.9691L36.75 33.875C36.75 36.4596 38.8529 38.5625 41.4375 38.5625H43.3125C45.8971 38.5625 48 36.4596 48 33.875L43.7619 23.5625H46.125ZM24.906 32.9375H18.344L21.625 25.0621L24.906 32.9375ZM45.656 32.9375H39.094L42.375 25.0621L45.656 32.9375Z",
    fill: "url(#paint1_linear_4636_42612)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4636_42612",
    x1: 23.5625,
    y1: 44.1875,
    x2: 31.3406,
    y2: 54.7187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4636_42612",
    x1: 16,
    y1: 16,
    x2: 52.7084,
    y2: 29.6561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4636_42612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffic);
export default __webpack_public_path__ + "static/media/traffic.1e5fc6b047a9c9358b2d4f1b0168832c.svg";
export { ForwardRef as ReactComponent };